import { BrandfolderHexColors } from '../enums/colors.js';
import { brandfolderColorPalette } from './colors.js';

const textButtonBorderTransparent = {
    borderColor: 'transparent',
    borderColorActive: 'transparent',
    borderColorDisabled: 'transparent',
    borderColorFocus: 'transparent',
    borderColorHover: 'transparent'
};
const blackButton = {
    backgroundColor: 'transparent',
    backgroundColorActive: '#F9FBFC',
    backgroundColorDisabled: 'transparent',
    backgroundColorFocus: '#F1F5FA',
    backgroundColorHover: '#F1F5FA',
    outlineColorFocus: '#6f6f6f',
    textColor: BrandfolderHexColors.Text,
    textColorActive: '#9B9B9B',
    textColorFocus: '#6f6f6f',
    textColorHover: '#6f6f6f',
    textColorDisabled: '#BCBCBC',
    ...textButtonBorderTransparent
};
const dangerButton = {
    backgroundColor: BrandfolderHexColors.Delete,
    backgroundColorActive: '#000000',
    backgroundColorDisabled: '#F5F5F5',
    backgroundColorFocus: BrandfolderHexColors.Delete,
    backgroundColorHover: '#B30016',
    borderColor: BrandfolderHexColors.Delete,
    borderColorActive: '#000000',
    borderColorDisabled: '#F5F5F5',
    borderColorFocus: BrandfolderHexColors.Delete,
    borderColorHover: '#B30016',
    outlineColorFocus: BrandfolderHexColors.Delete,
    textColor: '#FFFFFF',
    textColorActive: '#FFFFFF',
    textColorFocus: '#FFFFFF',
    textColorHover: '#FFFFFF',
    textColorDisabled: '#BCBCBC'
};
const primaryButton = {
    backgroundColor: brandfolderColorPalette.primary[700],
    backgroundColorActive: brandfolderColorPalette.primary[900],
    backgroundColorDisabled: brandfolderColorPalette.neutrals[100],
    backgroundColorFocus: brandfolderColorPalette.primary[700],
    backgroundColorHover: brandfolderColorPalette.primary[800],
    borderColor: brandfolderColorPalette.primary[700],
    borderColorActive: brandfolderColorPalette.primary[900],
    borderColorDisabled: brandfolderColorPalette.neutrals[100],
    borderColorFocus: brandfolderColorPalette.primary[700],
    borderColorHover: brandfolderColorPalette.primary[800],
    outlineColorFocus: brandfolderColorPalette.primary[700],
    textColor: brandfolderColorPalette.neutrals[0],
    textColorActive: brandfolderColorPalette.neutrals[0],
    textColorFocus: brandfolderColorPalette.neutrals[0],
    textColorHover: brandfolderColorPalette.neutrals[0],
    textColorDisabled: brandfolderColorPalette.neutrals[400]
};
const secondaryButton = {
    backgroundColor: '#FFFFFF',
    backgroundColorActive: '#F1F5FA',
    backgroundColorDisabled: '#FFFFFF',
    backgroundColorFocus: '#FFFFFF',
    backgroundColorHover: '#F1F5FA',
    borderColor: '#4462C9',
    borderColorActive: '#4A4A4A',
    borderColorDisabled: '#BCBCBC',
    borderColorFocus: '#4462C9',
    borderColorHover: '#4462C9',
    outlineColorFocus: '#4462C9',
    textColor: '#4462C9',
    textColorActive: '#4A4A4A',
    textColorFocus: '#4462C9',
    textColorHover: '#4462C9',
    textColorDisabled: '#BCBCBC'
};
const tertiaryButton = {
    backgroundColor: '#FFFFFF',
    backgroundColorActive: '#F1F5FA',
    backgroundColorDisabled: '#FFFFFF',
    backgroundColorFocus: '#FFFFFF',
    backgroundColorHover: '#F1F5FA',
    borderColor: '#E2E2E2',
    borderColorActive: '#4A4A4A',
    borderColorDisabled: '#BCBCBC',
    borderColorFocus: '#9EAFE2',
    borderColorHover: '#4462C9',
    outlineColorFocus: '#4462C9',
    textColor: '#4A4A4A',
    textColorActive: '#4A4A4A',
    textColorFocus: '#4A4A4A',
    textColorHover: '#4462C9',
    textColorDisabled: '#BCBCBC'
};
const warningButton = {
    backgroundColor: '#FFFFFF',
    backgroundColorActive: '#000000',
    backgroundColorDisabled: '#F5F5F5',
    backgroundColorFocus: BrandfolderHexColors.Delete,
    backgroundColorHover: '#B30016',
    borderColor: BrandfolderHexColors.Delete,
    borderColorActive: '#000000',
    borderColorDisabled: '#F5F5F5',
    borderColorFocus: BrandfolderHexColors.Delete,
    borderColorHover: '#B30016',
    outlineColorFocus: BrandfolderHexColors.Delete,
    textColor: BrandfolderHexColors.Delete,
    textColorActive: '#FFFFFF',
    textColorFocus: '#FFFFFF',
    textColorHover: '#FFFFFF',
    textColorDisabled: '#BCBCBC'
};
const whiteButton = {
    backgroundColor: 'transparent',
    backgroundColorActive: 'transparent',
    backgroundColorDisabled: 'transparent',
    backgroundColorFocus: 'transparent',
    backgroundColorHover: 'transparent',
    outlineColorFocus: '#E6E6E6',
    textColor: '#fff',
    textColorActive: '#CBCBCB',
    textColorFocus: '#E6E6E6',
    textColorHover: '#E6E6E6',
    textColorDisabled: '#BCBCBC',
    ...textButtonBorderTransparent
};
const textSecondaryButton = {
    ...secondaryButton,
    ...textButtonBorderTransparent
};
const textTertiaryButton = {
    ...tertiaryButton,
    ...textButtonBorderTransparent
};
const textWarningButton = {
    ...warningButton,
    ...textButtonBorderTransparent
};

export { blackButton, dangerButton, primaryButton, secondaryButton, tertiaryButton, textSecondaryButton, textTertiaryButton, textWarningButton, warningButton, whiteButton };
//# sourceMappingURL=button.js.map
